export interface Testimonial {
  name: string;
  role: string;
  rating: number;
  comment: string;
  imageAlt: string;
}

export const testimonials: Testimonial[] = [
    {
      name: "Laura Gómez",
      role: "Arquitecta",
      rating: 5,
      comment: "Un trabajo impecable y muy profesional. Cumplieron con los tiempos y la calidad del aluminio es excelente. Los recomiendo ampliamente.",
      imageAlt: "Arquitecta sonriendo satisfecha con el proyecto"
    },
    {
      name: "Javier Torres",
      role: "Propietario de Vivienda",
      rating: 5,
      comment: "Cambiaron todas las ventanas de mi casa y el resultado fue espectacular. Ahora tengo mejor aislamiento y se ven increíbles. ¡Gracias!",
      imageAlt: "Hombre feliz en su casa renovada con nuevas ventanas"
    },
    {
      name: "Constructora Delta",
      role: "Empresa de Construcción",
      rating: 5,
      comment: "Son nuestro proveedor de confianza para cancelería en todos nuestros proyectos. Siempre entregan calidad y un servicio al cliente de primera.",
      imageAlt: "Logo de una empresa constructora moderna"
    }
];
